<script setup lang="ts">
import type { CloudPlusCountChangeErrorPayload, OrganizationJs } from "@/generated/models";
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import { SimpleDialogContent, SimpleDialogDescription } from "ls/components/simple-dialog";
import FreemiumMoveBlockSection from "ls/features/organizations/SettingsOrganizationUpgradePlan/FreemiumMoveBlockSection.vue";
import FreemiumUsageSection from "ls/features/organizations/SettingsOrganizationUpgradePlan/FreemiumUsageSection.vue";
import UpgradePlansSection from "ls/features/organizations/SettingsOrganizationUpgradePlan/UpgradePlansSection.vue";
import { toOrganizationBilling } from "ls/router/builders";
import { DialogClose } from "reka-ui";
import { CloudPlusCountChangeRequestType } from "@/generated/models";

const props = defineProps<{
  organization: OrganizationJs;
  payload?: CloudPlusCountChangeErrorPayload;
}>();
</script>

<template>
  <SimpleDialogContent variant="x-large" background-color="grey">
    <SimpleDialogDescription class="sr-only">
      Axure Cloud Plus usage and upgrade options
    </SimpleDialogDescription>
    <div class="flex justify-between gap-6">
      <div class="flex-1">
        <div class="flex h-full flex-col justify-between">
          <div class="mb-4 flex bg-slate-100 text-slate-500">
            <FreemiumMoveBlockSection v-if="payload?.RequestType === CloudPlusCountChangeRequestType.Move" :organization="props.organization" />
            <FreemiumUsageSection v-else :organization="props.organization" />
          </div>
          <div>
            Go to
            <DialogClose>
              <SimpleButton variant="link" size="auto" :href="toOrganizationBilling(props.organization)">
                billing
              </SimpleButton>
            </DialogClose>
            to manage subscriptions. Questions?
            <SimpleButton variant="link" size="auto" target="_blank" href="https://www.axure.com/contact-us">
              Contact us
            </SimpleButton>
          </div>
        </div>
      </div>
      <div class="max-w-64">
        <UpgradePlansSection :organization="props.organization" />
      </div>
    </div>
  </SimpleDialogContent>
</template>
